/* CSS */
import "@js/parts/css";

/**
 * Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
 */
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log('HMR');
    });
}

// Project Imports
import env from '@js/utils/env';
import utils from '@js/utils/utils';
import Signal from '@js/classes/Signal';
import DelayedCall from '@js/helpers/DelayedCall';
import ElementsHeightCalc from '@js/helpers/ElementsHeightCalc';

import CookieMessage from '@js/modules/CookieMessage';
import Page from '@js/modules/Page';
import PageScrollingManager from '@js/modules/PageScrollingManager';
import PageScrolling from '@js/modules/PageScrolling';
// import ScrollTo from '@js/modules/ScrollTo';

window.WAZZO =
    window.WAZZO ||
    new (function WAZZO() {
        this.env = env;

        this.utils = utils;

        this.classes = {
            Signal: Signal,
        };

        this.helpers = {
            DelayedCall: DelayedCall,
            ElementsHeightCalc: ElementsHeightCalc,
        };

        this.modules = {
            PageScrollingManager: PageScrollingManager,
            PageScrolling: PageScrolling,
        };

        PageScrolling.start();

        // Window Load
        window.addEventListener('load', e => {
            PageScrollingManager.update(true);
        });

        // DOM load
        document.addEventListener('DOMContentLoaded', e => {
            Page.init();
        });
    })();
